import { useModal, useUrlFilter, useUrlPagination } from '@/hooks';

import { MODAL_ROUTE } from '../../../../constants';
import { useGetTypesQuery } from '../../../../features/slice/products/type/type-api-slice';

export const useTypeList = () => {
    const { debouncedSearchText, sortBy, sortOrder } = useUrlFilter();
    const { page, limit } = useUrlPagination();
    const { openModal } = useModal();

    const { data, isLoading, isFetching, isError, error } = useGetTypesQuery({
        page,
        limit,
        search: debouncedSearchText,
        sort_by: sortBy,
        sort_order: sortOrder,
    });

    const handleCreateType = () => {
        openModal(MODAL_ROUTE.CREATE_PRODUCT_TYPE);
    };

    return {
        data,
        isLoading,
        isFetching,
        isError,
        error,
        handleCreateType,
    };
};
